import { GreenhouseInstance } from '../../../../typings/custom/greenhouse';

const Greenhouse: GreenhouseInstance =
  window && window.Greenhouse ? window.Greenhouse : {};

export default Greenhouse;
